<template>
  <div>
    <!-- edit vehicle modal -->
    <modal
      name="edit-vehicle-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-vehicle
        :selectedVehicle="selectedVehicle"
        :isSaveAndProceedButtonVisible="false"
        title="UREDI VOZILO"
        @saveAndCloseButtonClicked="editVehicle"
      />
    </modal>

    <!-- add vehicle modal -->
    <modal
      name="add-vehicle-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-vehicle
        :selectedVehicle="selectedVehicle"
        :isSaveAndProceedButtonVisible="false"
        title="DODAJ KARTICU"
        @saveAndCloseButtonClicked="addVehicle"
      />
    </modal>

    <!-- delete vehicle modal -->
    <modal
      name="delete-vehicle-modal"
      :adaptive="true"
      :reset="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <delete-item
        message="Da li zaista žekite da obrišete karticu"
        title="OBRIŠI KARTICU"
        :selectedItem="selectedVehicle"
        @deleteButtonClicked="deleteVehicle"
      />
    </modal>

    <!-- Title -->
    <h1 class="title has-text-success">Vozila</h1>
    <h2 class="subtitle">Administracija vozila u preduzeću.</h2>

    <!-- Table -->
    <vue-good-table
      theme="polar-bear"
      :columns="columns"
      :rows="rows"
      styleClass="vgt-table striped"
      :group-options="{
        enabled: true,
      }"
      :search-options="{
        enabled: true,
        searchFn: searchFunc,
        placeholder: 'Pretraži...',
      }"
    >
      <template slot="table-header-row" slot-scope="props">
        <span class="">
          <h2 class="is-size-6 has-text-weight-semibold has-text-left">
            {{ props.row.label }}
          </h2>
        </span>
      </template>
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'before'">
          <!-- edit icon -->
          <span class="icon has-text-info">
            <i
              class="fas fa-edit"
              v-show="props.row.isnew === false"
              @click="editRow(props.row)"
            >
              <font-awesome-icon icon="edit" />
            </i>
          </span>
          <!-- delete icon -->
          <span class="icon has-text-danger">
            <i
              class="fas fa-trash-alt"
              v-show="props.row.isnew === false"
              @click="deleteRow(props.row)"
            >
              <font-awesome-icon icon="trash-alt" />
            </i>
          </span>
          <!-- add new row button -->
          <button
            class="button is-info is-size-7"
            v-show="props.row.isnew === true"
            @click="addRow(props.row)"
          >
            Dodaj
          </button>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import UserService from "../../services/user.service";
import EditVehicle from "../parts/EditVehicle.vue";
import DeleteItem from "../parts/DeleteItem.vue";
import "vue-good-table/dist/vue-good-table.css";
import "vue-select/dist/vue-select.css";
import { VueGoodTable } from "vue-good-table";
import { VehicleBack, VehicleFront } from "../../models/vehicle";

export default {
  components: {
    VueGoodTable,
    EditVehicle,
    DeleteItem,
  },
  name: "Vehicles",
  data() {
    return {
      selectedVehicle: VehicleFront,

      employees: [],

      columns: [
        {
          label: "Akcije",
          field: "before",
          sortable: false,
        },
        {
          label: "Broj tablice",
          field: "licensePlate",
          sortable: false,
        },
        {
          label: "UHF kartica",
          field: "card",
          sortable: false,
        },
        {
          label: "Model",
          field: "model",
          sortable: false,
        },
        {
          label: "Tip",
          field: "vehicleType",
          sortable: false,
        },
        {
          label: "GPS broj",
          field: "gpsNumber",
          type: "number",
          sortable: false,
        },
        {
          label: "Privatno vozilo",
          field: "isPrivate",
          sortable: false,
        },
      ],
      rows: [],
      errorMessage: "",
    };
  },
  mounted() {
    this.getEmployees();
  },
  methods: {
    getEmployees() {
      UserService.getEmployees().then((response) => {
        // reset ui
        this.resetUi();

        // get new data
        response.data.forEach((element) => {
          // populate employees
          this.employees.push({
            firstName: element.firstName,
            lastName: element.lastName,
            id: element.employeeId,
          });

          // populate rows
          let newVehicles = [];
          element.vehicle.forEach((vehicle) => {
            let vhcl = new VehicleFront(vehicle);
            vhcl.updateEmployee(
              element.employeeId,
              element.firstName,
              element.lastName
            );
            newVehicles.push(vhcl);
          });
          let newRow = {
            mode: "span",
            label:
              element.firstName +
              " " +
              element.lastName +
              " (id: " +
              element.employeeId +
              ")",
            html: false,
            children: newVehicles,
          };
          newRow.children.push(
            new VehicleFront({
              vehicleId: null,
              remoteId: null,
              licensePlate: null,
              description: null,
              isPrivate: null,
              vehicleType: null,
              validFrom: null,
              validUntil: null,
              employeeId: null,
              vendorId: null,
              gpsNumber: null,
              forTerrain: null,
              numberOfDoors: null,
              model: null,
              productionYear: null,
              note: null,
              kilometerCount: null,
              chargeDate: null,
              weight: null,
              card: null,
              cardType: null,
              companyId: this.$store.state.general.companyId,
              employee: {
                id: null,
                firstName: null,
                lastName: null,
                hiddenId: element.employeeId,
                hiddenFirstName: element.firstName,
                hiddenLastName: element.lastName,
              },
              isnew: true,
            })
          );
          this.rows.push(newRow);
        });
        // get free vehicles
        this.getFreeVehicles();
      });
    },
    getFreeVehicles() {
      UserService.getFreeVehicles().then((response) => {
        // get new data
        let freeVehicles = [];
        response.data.forEach((vehicle) => {
          let fveh = new VehicleFront(vehicle);
          fveh.updateEmployee(null, "Slobodno", "Vozilo");
          freeVehicles.push(fveh);
        });

        let newRow = {
          mode: "span",
          label: "Slobodno Vozilo",
          html: false,
          children: freeVehicles,
        };
        newRow.children.push(
          new VehicleFront({
            vehicleId: null,
            remoteId: null,
            licensePlate: null,
            description: null,
            isPrivate: null,
            vehicleType: null,
            validFrom: null,
            validUntil: null,
            employeeId: null,
            vendorId: null,
            gpsNumber: null,
            forTerrain: null,
            numberOfDoors: null,
            model: null,
            productionYear: null,
            note: null,
            kilometerCount: null,
            chargeDate: null,
            weight: null,
            card: null,
            cardType: null,
            companyId: this.$store.state.general.companyId,
            employee: {
              id: null,
              firstName: null,
              lastName: null,
              hiddenId: null,
              hiddenFirstName: "Slobodno",
              hiddenLastName: "Vozilo",
            },
            isnew: true,
          })
        );
        this.rows.push(newRow);
      });
    },
    searchFunc(row, col, cellValue, searchTerm) {
      let isVehicle = false;
      let isName = false;
      let isHiddenName = false;
      let theName = "";
      let theHiddenName = "";
      if (typeof cellValue === "string" || cellValue instanceof String) {
        isVehicle = cellValue.toLowerCase().includes(searchTerm.toLowerCase());
      }
      if (row.employee.firstName !== null) {
        theName = theName + row.employee.firstName;
      }
      if (row.employee.lastName !== null) {
        theName = theName + " " + row.employee.lastName;
      }
      if (row.employee.hiddenFirstName !== null) {
        theHiddenName = theHiddenName + row.employee.hiddenFirstName;
      }
      if (row.employee.hiddenLastName !== null) {
        theHiddenName = theHiddenName + " " + row.employee.hiddenLastName;
      }
      isName = theName.toLowerCase().includes(searchTerm.toLowerCase());
      isHiddenName = theHiddenName
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
      if (isName || isHiddenName || isVehicle) {
        return true;
      } else return false;
    },
    resetUi() {
      this.employees = [];
      this.rows = [];
    },
    addRow(vhcl) {
      this.selectedVehicle = vhcl;
      this.selectedVehicle.isActive = true;
      console.log(vhcl);
      this.$modal.show("add-vehicle-modal");
    },
    deleteRow(vhcl) {
      this.selectedVehicle = vhcl;
      this.$modal.show("delete-vehicle-modal");
    },
    editRow(vhcl) {
      this.selectedVehicle = vhcl;
      this.selectedVehicle.isActive = true;
      console.log(vhcl);
      this.$modal.show("edit-vehicle-modal");
    },
    editVehicle(vhcl) {
      let vehicleToEdit = new VehicleBack(vhcl);

      UserService.putVehicle(vehicleToEdit).then(
        () => {
          // reload UI
          this.resetUi();

          this.getEmployees();
        },
        (error) => {
          this.errorMessage = this.collectErrorMessage(error);
          console.log(error);
        }
      );

      this.$modal.hide("edit-vehicle-modal");
    },
    addVehicle(vhcl) {
      // create new vehicle
      let newVehicle = new VehicleBack(vhcl);

      // call axios
      UserService.postVehicle(newVehicle).then(() => {
        this.getEmployees();

        // reset UI
        this.resetSelectedVehicle();
        this.$modal.hide("add-vehicle-modal");
      });
    },
    deleteVehicle() {
      let vehicleToDelete = new VehicleBack(this.selectedVehicle);

      UserService.deleteVehicle(vehicleToDelete).then(
        () => {
          // reload emps
          this.resetUi();

          this.getEmployees();
        },
        (error) => {
          this.errorMessage = this.collectErrorMessage(error);
        }
      );
    },
    resetSelectedVehicle() {
      this.selectedVehicle = new VehicleFront({
        employee: {
          id: null,
          firstName: null,
          lastName: null,
        },
      });
    },
    collectErrorMessage(error) {
      let msg =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      return msg;
    },
  },
};
</script>
